(function() {
  // Wait for jQuery + DOM
  function init() {
    if (typeof jQuery === 'undefined') {
      setTimeout(init, 50);
      return;
    }
    var $ = jQuery;
    var config = window.PiqueCartConfig || {};

    window.baseThreshold = config.freeShippingThreshold;
    window.baseCurrency  = config.currency;

    // ── Helpers ─────────────────────────────────────────────────────────────
    function getCookie(n) {
      for (var t = n + "=", r = document.cookie.split(";"), e = 0; e < r.length; e++) {
        for (var i = r[e]; " " == i.charAt(0);) i = i.substring(1, i.length);
        if (0 == i.indexOf(t)) return i.substring(t.length, i.length);
      }
      return null;
    }

    function GetURLParameter(sParam) {
      var sPageURL = window.location.search.substring(1);
      var sURLVariables = sPageURL.split('&');
      for (var i = 0; i < sURLVariables.length; i++) {
        var sParameterName = sURLVariables[i].split('=');
        if (sParameterName[0] == sParam) return sParameterName[1];
      }
    }

    function paidProductsInCart(cart) {
      return cart.items.filter(function(item) {
        return item.id !== 40384172949602;
      }).length;
    }
    function getReferralCampaign() {
  // 1. Live URL parameter (original behavior)
  var fromUrl = GetURLParameter('utm_campaign');
  if (fromUrl) { return fromUrl; }

  // 2. sessionStorage: as-customer-trigger-data (only set when arriving via referral link)
  try {
    var trigger = sessionStorage.getItem('as-customer-trigger-data');
    if (trigger) {
      var parsed = JSON.parse(trigger);
      if (parsed && parsed.utm_campaign) { return parsed.utm_campaign; }
    }
  } catch (e) {}

  return undefined;
}

    // ── Cart API ─────────────────────────────────────────────────────────────
    Shopify.Cart = Shopify.Cart || {};
    Shopify.Cart.GiftWrap = {};
    var giftQueue = Promise.resolve();
    var pendingAdds = {};

    function enqueueGift(task) {
      giftQueue = giftQueue.then(task).catch(function(err) {
        console.error('GiftWrap queue error:', err);
      });
      return giftQueue;
    }

    Shopify.Cart.GiftWrap.set = function(variantid, quantity, properties) {
      var noGiftMarkets = ['AU', 'SG', 'HK'];
  if (noGiftMarkets.indexOf(config.currentCountry) !== -1) {
    return giftQueue; // blocked market → never add any gift
  }
  // Skip if this gift is already being added in this cycle
  if (pendingAdds[variantid]) { return giftQueue; }
  pendingAdds[variantid] = true;

  return enqueueGift(function() {
    // Re-check live cart right before adding, so we never double-add
    return fetch('/cart.js')
      .then(function(r) { return r.json(); })
      .then(function(cart) {
        var existing = cart.items.find(function(i) { return i.id === variantid; });
        if (existing) { return; } // already in cart, do nothing
        var payload = { id: variantid, quantity: 1 };
        if (properties) { payload.properties = properties; }
        return fetch('/cart/add.js', {
          method: 'POST',
          headers: new Headers({ 'Content-Type': 'application/json' }),
          body: JSON.stringify(payload)
        }).then(function() {
          document.dispatchEvent(new CustomEvent('product:added', {
            bubbles: true,
            detail: { variant: variantid, quantity: 1 }
          }));
        });
      })
      .finally(function() { pendingAdds[variantid] = false; });
  });
};

    var protectedGiftIds = {};

    Shopify.Cart.GiftWrap.remove = function(productId) {
      if (protectedGiftIds[Number(productId)]) { return; }
      $.ajax({
        method: 'POST',
        url: '/cart/change.js',
        dataType: 'json',
        data: { quantity: 0, id: productId }
      }).then(function() {
        document.dispatchEvent(new CustomEvent('product:added', {
          bubbles: true,
          detail: { variant: productId, quantity: 0 }
        }));
      });
    };

    /**
     * Remove outgoing gifts and add the replacement in one queued cycle.
     * Shopify cannot add + remove in a single Ajax call, so this is update.js
     * then add.js, with one cart refresh at the end (avoids a double drawer reload).
     * `updates` is variant id → quantity (0 to remove).
     * `addItem` is { id, properties } or null.
     */
    Shopify.Cart.GiftWrap.sync = function(updates, addItem) {
      var hasUpdates = updates && Object.keys(updates).length > 0;
      if (!hasUpdates && !addItem) return giftQueue;

      if (addItem) {
        if (pendingAdds[addItem.id]) addItem = null;
        else pendingAdds[addItem.id] = true;
      }

      return enqueueGift(function() {
        var chain = Promise.resolve();

        if (hasUpdates) {
          chain = chain.then(function() {
            return fetch('/cart/update.js', {
              method: 'POST',
              headers: { 'Content-Type': 'application/json' },
              body: JSON.stringify({ updates: updates })
            });
          });
        }

        if (addItem) {
          var incoming = addItem;
          chain = chain.then(function() {
            return fetch('/cart.js')
              .then(function(response) { return response.json(); })
              .then(function(liveCart) {
                var existing = liveCart.items.find(function(item) { return item.id === incoming.id; });
                if (existing) return;
                var payload = { id: incoming.id, quantity: 1 };
                if (incoming.properties) payload.properties = incoming.properties;
                return fetch('/cart/add.js', {
                  method: 'POST',
                  headers: { 'Content-Type': 'application/json' },
                  body: JSON.stringify(payload)
                });
              });
          });
        }

        return chain
          .then(function() {
            document.dispatchEvent(new CustomEvent('product:added', {
              bubbles: true,
              detail: { variant: addItem ? addItem.id : 0, quantity: addItem ? 1 : 0 }
            }));
          })
          .finally(function() {
            if (addItem) pendingAdds[addItem.id] = false;
          });
      });
    };

    var BUNDLE_DISCOUNT_CODE = '20OFFSUB';

          function applyDiscountCode(code) {
  document.cookie = 'discount_code=' + code + '; path=/';
  return fetch('/discount/' + encodeURIComponent(code), { method: 'GET' });
}
   function clearDiscountCode() {
  document.cookie = 'discount_code=; path=/; expires=Thu, 01 Jan 1970 00:00:00 GMT';
  return fetch('/cart/update.js', {
    method: 'POST',
    headers: { 'Content-Type': 'application/json' },
    body: JSON.stringify({ discount: '' })
  }).then(function(r){ return r.json(); })
    .catch(function(e){ console.error('clear error:', e); });
}
    function showOptimisticSubtotal(discountRate) {
      try {
        return fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
          var eligibleCents = 0;
          cart.items.forEach(function(it) {
            var isBundle = it.properties && (it.properties._bundle_parent || it.properties._subscription_bundle === 'true');
            var noSl = !(it.properties && it.properties._sl_plan === 'true');
            if (isBundle && noSl && it.selling_plan_allocation) {
              eligibleCents += it.final_line_price;
            }
          });
          if (!eligibleCents) return;
          var otherCents = cart.total_price - eligibleCents;
          var optimisticCents = otherCents + Math.round(eligibleCents * (1 - discountRate));
          var el = document.querySelector('.Cart__Subtotal--price');
          if (!el) return;
          var symbol = (el.textContent || '').trim().charAt(0);
          if (symbol < '0' || symbol > '9') { /* keep currency symbol */ } else { symbol = '$'; }
          var dollars = optimisticCents / 100;
          var formatted = (dollars % 1 === 0) ? symbol + dollars.toFixed(0) : symbol + dollars.toFixed(2);
          el.textContent = formatted;
          el.setAttribute('data-optimistic', '1');
        }).catch(function(){ /* display-only; ignore */ });
      } catch (e) { /* display-only; ignore */ }
    }

    // ── Gift logic (runs AFTER the discount has settled) ─────────────────────
    function runGiftLogic(cart, total_price, refferal_cookie_value, product_ttl, product_affliate) {
        var currency   = Shopify.currency.active;
        var threshold  = window.baseThreshold;
        var totalPrice = total_price;

        var carraraInCart = false, carraraScoopInCart = false, carraraKitInCart = false, carraraWelcomeKIt = false, carraraKitSubInCart= false, dhpGiftInCart2 = false;
        var dhpComp1Sub = false, dhpComp2Sub = false, rsdComp1Sub = false, rsdComp2Sub = false, nandakaSub = false, shlpComp1Sub = false, shlpComp2Sub = false, shlpComp3Sub = false, shlpGiftInCart2 = false;
        var welcomeKitGift = 43334710329442;
        var slGiftSamples = 42402135605346;   // SAMPLEPACK — 12 samples (BTF 30-day)
        var slGiftBundle = 50523153268834;    // BLPSK4001 — four gifts as one line (90-day)
        var slBtfVariant = 43350435889250;
        var slRsdParent = 50511919251554;
        var slBtfStandalone = null;
        var slRsdChildren = [];
        var slGiftState = { bundle: false, samples: false, welcome: false, owned: {} };
        protectedGiftIds = {};
        var puerBlackGhpInCart = false, puerGreenGhpInCart = false;
        var dhpGhpComp1Sub = false, dhpGhpComp2Sub = false, hasNewGift = false;
        var b, c, e, d, p, q, r, x, y, z, x2, y2, d1, z1, d2, b1, p1, p2, p3, p4, n, n1, n2, f, ret, retq, fb, o;
        var selling_plans_nandak, n3, n4, n5, selling_plans_nandak_hbp, selling_plans_3;
        var final_price_lineitem_nandaka, n6, n7, n8, p5, p6, s, n9, n10, n11;
        var selling_plans_pbs, y1, d12, selling_plans1, z2, x1, e1, r1, d13, pb, pbf, pb1, hb, hbf, hb1;
        var g;
        var noGiftMarkets = ['AU', 'SG', 'HK'];
        var giftsAllowed = noGiftMarkets.indexOf(config.currentCountry) === -1;

        // ── Stable paid-product subtotal (excludes gift lines) for the $115 threshold ──
        var giftIdsForThreshold = [39611069464674, 39548746236002, 40384172949602, 40217016500322,
          41453574717538, 42402129051746, 42402135605346, 42584519770210,
          40452231299170, 42220643221602, 42772944650338, 42838950969442, 42838975447138,
          50571175493730, 43334710329442, 42609638244450, 50589222830178, 42609800282210,
          50523153268834];
        var paidSubtotalCents = 0;
        cart.items.forEach(function(item) {
          if (giftIdsForThreshold.indexOf(item.id) === -1 && item.final_line_price > 0 && !item.gift_card) {
            paidSubtotalCents += item.final_line_price;
          }
        });
        var paidTotal = paidSubtotalCents / 100;

        cart.items.forEach(function(a) {
          if (a.id === 42754775351394) { x = a.quantity; carraraInCart = true; }
          if (a.id === 42772944650338) { carraraScoopInCart = true; g = a.quantity; }
          if (a.id === 41406427463778) { o = a.id; }
          if (a.id === 50571175493730) { hasNewGift = true; }
          if (a.id === 43177274146914) { carraraKitInCart = true; }
          if (a.id === 43177274146914 && a.selling_plan_allocation) { carraraKitSubInCart = true; }
          if (a.id === 43334710329442) { p1 = a.id; carraraWelcomeKIt = true; }
          if (a.id === 43227330052194 && a.selling_plan_allocation) { nandakaSub = true; }
          if (a.id === 31372204507234 && a.selling_plan_allocation) { puerBlackGhpInCart = true; }
          if (a.id === 31372214992994 && a.selling_plan_allocation) { puerGreenGhpInCart = true; }
          if (a.id === 39579586723938 && a.selling_plan_allocation) { dhpGhpComp1Sub = true; }
          if (a.id === 41962239787106 && a.selling_plan_allocation) { dhpGhpComp2Sub = true; }
          if (Number(a.properties && a.properties._bundle_parent) === 43206238044258 && a.selling_plan_allocation) {
          if (a.id === 39579586723938) { dhpComp1Sub = true; }
          if (a.id === 41962239787106) { dhpComp2Sub = true; }
         }
         if (Number(a.properties && a.properties._bundle_parent) === 43206212485218 && a.selling_plan_allocation) {
            if (a.id === 39579586723938) { rsdComp1Sub = true; }
            if (a.id === 15760607576162) { rsdComp2Sub = true; }
          }
          if (Number(a.properties && a.properties._bundle_parent) === 50583489708130 && a.selling_plan_allocation) {
            if (a.id === 39579586723938) { shlpComp1Sub = true; }
            if (a.id === 15760607576162) { shlpComp2Sub = true; }
            if (a.id === 42754775351394) { shlpComp3Sub = true; }
          }
          if (a.id === 42609638244450) { dhpGiftInCart2 = true; }
          if (a.id === 50589222830178) { shlpGiftInCart2 = true; }
          var slBundleParent = Number(a.properties && a.properties._bundle_parent) || 0;
          if (a.selling_plan_allocation && slBundleParent === slRsdParent) slRsdChildren.push(a);
          if (a.selling_plan_allocation && !slBundleParent && a.id === slBtfVariant) slBtfStandalone = a;
          if (a.id === slGiftBundle) slGiftState.bundle = true;
          if (a.id === slGiftSamples) slGiftState.samples = true;
          if (a.id === welcomeKitGift) slGiftState.welcome = true;
          if (a.properties && a.properties._supply_length_gift) slGiftState.owned[a.id] = true;
        });
        var dhpBundleQualifies = dhpComp1Sub && dhpComp2Sub;
        var rsdBundleQualifies = rsdComp1Sub && rsdComp2Sub;
        var shlpBundleQualifies = shlpComp1Sub && shlpComp2Sub && shlpComp3Sub;

        var slEarnedGift = 0;
        if (slRsdChildren.length) {
          var slRsdAllAtThree = slRsdChildren.length >= 2 && slRsdChildren.every(function(item) {
            return item.quantity >= 3;
          });
          slEarnedGift = slRsdAllAtThree ? slGiftBundle : welcomeKitGift;
        } else if (slBtfStandalone) {
          slEarnedGift = slBtfStandalone.quantity >= 3 ? slGiftBundle : slGiftSamples;
        }
        if (!giftsAllowed) slEarnedGift = 0;
        var anySupplyLengthGiftEarned = slEarnedGift !== 0;
        // A later generic remove strips the sample pack unless it is protected.
        // Shield SL kits from that path; we drop them via GiftWrap.sync only.
        protectedGiftIds[slGiftSamples] = true;
        protectedGiftIds[slGiftBundle] = true;
        if (slEarnedGift) protectedGiftIds[slEarnedGift] = true;

        var needsScoop = (carraraInCart || carraraKitInCart) && !shlpBundleQualifies;

        if (giftsAllowed && needsScoop && !carraraScoopInCart) {
          Shopify.Cart.GiftWrap.set(42772944650338, 1);
        } else if ((!giftsAllowed || !needsScoop) && carraraScoopInCart) {
          Shopify.Cart.GiftWrap.remove(42772944650338);
        }

        if (!giftsAllowed) {
            if (hasNewGift) { Shopify.Cart.GiftWrap.remove(50571175493730); }
          } else {
            if (paidTotal >= 115 && !hasNewGift) {
              Shopify.Cart.GiftWrap.set(50571175493730, 1);
            } else if (paidTotal < 115 && hasNewGift) {
              Shopify.Cart.GiftWrap.remove(50571175493730);
            }
          }

        var puerGhpBundleQualifies = config.isPuerGhpListicle && puerBlackGhpInCart && puerGreenGhpInCart;
        var dhpGhpProductInCart = dhpGhpComp1Sub && dhpGhpComp2Sub;
        var dhpGhpQualifiesOnPage = config.isDHPGhpListicle && dhpGhpProductInCart;

        var otherWelcomeKit = giftsAllowed && (carraraKitSubInCart || rsdBundleQualifies || nandakaSub || puerGhpBundleQualifies);
        var welcomeKitQualifies = otherWelcomeKit || slEarnedGift === welcomeKitGift;

        var slUpdates = {};
        var slAdd = null;
        if (slGiftState.bundle && slEarnedGift !== slGiftBundle) slUpdates[slGiftBundle] = 0;
        if (slGiftState.samples && slEarnedGift !== slGiftSamples) slUpdates[slGiftSamples] = 0;
        if (slGiftState.welcome && slEarnedGift !== welcomeKitGift && !otherWelcomeKit) {
          slUpdates[welcomeKitGift] = 0;
        }
        if (slEarnedGift && (
          (slEarnedGift === slGiftBundle && !slGiftState.bundle) ||
          (slEarnedGift === slGiftSamples && !slGiftState.samples) ||
          (slEarnedGift === welcomeKitGift && !slGiftState.welcome && !otherWelcomeKit)
        )) {
          slAdd = { id: slEarnedGift, properties: { _supply_length_gift: 'true' } };
        }

        var slDidSync = Object.keys(slUpdates).length > 0 || slAdd;
        if (slDidSync) Shopify.Cart.GiftWrap.sync(slUpdates, slAdd);

        if (!anySupplyLengthGiftEarned) {
          if (welcomeKitQualifies && !carraraWelcomeKIt) {
            Shopify.Cart.GiftWrap.set(welcomeKitGift, 1);
          } else if (!welcomeKitQualifies && carraraWelcomeKIt) {
            Shopify.Cart.GiftWrap.remove(welcomeKitGift);
          }
        }

        if ((dhpBundleQualifies || dhpGhpQualifiesOnPage) && !dhpGiftInCart2) {
          Shopify.Cart.GiftWrap.set(42609638244450, 1);
        } else if (!dhpBundleQualifies && !dhpGhpQualifiesOnPage && dhpGiftInCart2) {
          Shopify.Cart.GiftWrap.remove(42609638244450);
        }
        if ( shlpBundleQualifies && !shlpGiftInCart2) {
            Shopify.Cart.GiftWrap.set(50589222830178, 1);
          } else if (!shlpBundleQualifies && shlpGiftInCart2) {
            Shopify.Cart.GiftWrap.remove(50589222830178);
          }
        if (o === 41406427463778) { Shopify.Cart.GiftWrap.remove(41406427463778); }

        var starterKitA = 42609635852386;
        var starterKitB = 42402129051746;
        var hasStarterKitA = false, hasStarterKitB = false;

        cart.items.forEach(function(item) {
          if (item.id === starterKitA) { hasStarterKitA = true; }
          if (item.id === starterKitB) { hasStarterKitB = true; }
        });

        // ── Gift wrap logic ────────────────────────────────────────────────
        var applyGiftWrap = config.applyGiftWrap;
        if (applyGiftWrap) {
          var dhpBundle = 42060262309986, liverBundle = 41740812648546, puerBundle = 29692103032930;
          var dhpGift = 42609638244450, commonGift = 42402129051746, byobGift = 39986972557410;
          var mothersDayBundle = 42838823665762, mothersDayGift = 42838950969442;
          var lpGiftIds = [40452231299170];
          var hasDhpBundle = false, hasLiverBundle = false, hasPuerBundle = false;
          var dhpGiftInCart = false, commonGiftInCart = false, finalPriceGiftCard, g11, byobGiftInCart = false;
          var hasSubscriptionProduct = false;
          var subscriptionTotal = 0;
          var hasMotherssDayBundleSubscription = false, mothersDayGiftInCart = false, hasLpGift = false;
          var bottleMeetsMinimum = totalPrice >= 115;

          cart.items.forEach(function(item) {
            if (item.id == dhpBundle)      { hasDhpBundle = true; }
            if (item.id == liverBundle)    { hasLiverBundle = true; }
            if (item.id == puerBundle)     { hasPuerBundle = true; }
            if (item.id == dhpGift)        { dhpGiftInCart = true; }
            if (item.id == commonGift)     { commonGiftInCart = true; }
            if (item.id == mothersDayGift) { mothersDayGiftInCart = true; }
            if (lpGiftIds.indexOf(item.id) !== -1) { hasLpGift = true; }
            if (item.gift_card) { g11 = item.quantity; finalPriceGiftCard = item.final_line_price; }
            if (item.selling_plan_allocation) {
              // Count ALL subscription lines — including bundle items — so a
              // bundle-only cart at $115+ qualifies for the starter kit.
              // Bundle-specific gifts (DHP/SHLP/SL) are still suppressed by
              // their own flags in qualifiesForWelcomeKit below.
              hasSubscriptionProduct = true;
              subscriptionTotal += item.final_line_price;
            }
            if (item.id == mothersDayBundle) { hasMotherssDayBundleSubscription = true; }
          });

          if (g11 >= 1) totalPrice -= finalPriceGiftCard / 100;

          if (hasMotherssDayBundleSubscription) {
            if (!mothersDayGiftInCart) { Shopify.Cart.GiftWrap.set(mothersDayGift, 1); }
            if (commonGiftInCart)      { Shopify.Cart.GiftWrap.remove(commonGift); }
          } else {
            if (mothersDayGiftInCart)  { Shopify.Cart.GiftWrap.remove(mothersDayGift); }

            var meetsOrderMinimum      = (subscriptionTotal / 100) >= 115;
            var qualifiesForWelcomeKit = giftsAllowed && meetsOrderMinimum && hasSubscriptionProduct && !hasLpGift && !hasStarterKitA && !carraraWelcomeKIt && !dhpGiftInCart2 && !shlpBundleQualifies && !anySupplyLengthGiftEarned;
            if (qualifiesForWelcomeKit) {
              if (!commonGiftInCart) { Shopify.Cart.GiftWrap.set(commonGift, 1); }
            } else {
              if (commonGiftInCart)  { Shopify.Cart.GiftWrap.remove(commonGift); }
            }
            if (carraraWelcomeKIt && commonGiftInCart) {
              Shopify.Cart.GiftWrap.remove(commonGift);
            }
            if (dhpGiftInCart2 && commonGiftInCart) {
              Shopify.Cart.GiftWrap.remove(commonGift);
            }
          }
           var lpThresholdMet = (subscriptionTotal / 100) >= 100;

            if (hasLpGift && !lpThresholdMet) {
              Shopify.Cart.GiftWrap.remove(40452231299170);
            }
            if (byobGiftInCart && !bottleMeetsMinimum) { Shopify.Cart.GiftWrap.remove(byobGift); }
        } else {
          var dhpBundle = 42060262309986, liverBundle = 41740812648546, puerBundle = 29692103032930;
          var dhpGift = 39986972557410, commonGift = 40452231299170, siteCommonGift = 42609800282210;
          var hasDhpBundle = false, hasLiverBundle = false, hasPuerBundle = false;
          var dhpGiftInCart = false, commonGiftInCart = false, siteCommonGiftInCart = false;
          var bundleSubtotal = 0;

          cart.items.forEach(function(item) {
            var parentId = Number(item.properties && item.properties._bundle_parent);
            var isSub    = item.selling_plan_allocation;
            if (isSub) { bundleSubtotal += item.original_line_price; }
            if (parentId === dhpBundle   && isSub && bundleSubtotal > 10000) { hasDhpBundle = true; }
            if (parentId === liverBundle && isSub) { hasLiverBundle = true; }
            if (parentId === puerBundle  && isSub) { hasPuerBundle = true; }
            if (item.id == dhpGift)        { dhpGiftInCart = true; }
            if (item.id == commonGift)     { commonGiftInCart = true; }
            if (item.id == siteCommonGift) { siteCommonGiftInCart = true; }
          });

          function syncGift(shouldHave, inCart, giftId) {
            if (shouldHave && !inCart)  { Shopify.Cart.GiftWrap.set(giftId, 1); }
            if (!shouldHave && inCart)  { Shopify.Cart.GiftWrap.remove(giftId); }
          }

          syncGift(hasDhpBundle, dhpGiftInCart, dhpGift);
          if (hasDhpBundle && commonGiftInCart) { Shopify.Cart.GiftWrap.remove(commonGift); }

          if (!hasDhpBundle) {
            var qualifies = bundleSubtotal >= 10000 || hasLiverBundle || hasPuerBundle;
            syncGift(qualifies, commonGiftInCart, commonGift);
          }
          if (siteCommonGiftInCart) { Shopify.Cart.GiftWrap.remove(siteCommonGift); }
        }

        // ── Additional gift/variant logic ──────────────────────────────────
        var hasSubscription = false;
        var bundleSubtotal2 = 0;
        cart.items.forEach(function(a) {
          if (a.id === 42609800282210) { p1 = a.id; }
          if (a.id === 42402135605346) { p2 = a.id; }
          if (a.id === 42609635852386) { p3 = a.id; }
          if (a.id === 42060262309986) { retq = a.quantity; ret = a.id; selling_plans_3 = a.selling_plan_allocation; }
          if (a.id === 40452231299170) { f = a.id; }
          if (a.selling_plan_allocation != null) { hasSubscription = true; bundleSubtotal2 += a.original_line_price; }
        });

        if (p2 === 42402135605346) { Shopify.Cart.GiftWrap.remove(42402135605346); }
        if (p3 === 42609635852386 && bundleSubtotal2 < 10000) { Shopify.Cart.GiftWrap.remove(42609635852386); }
        if (hasStarterKitA && hasStarterKitB) {
          Shopify.Cart.GiftWrap.remove(starterKitB);
        }

        // ── Referral candy free product ────────────────────────────────────
        if (typeof refferal_cookie_value !== "undefined" && refferal_cookie_value && refferal_cookie_value.includes("referralcandy_")) {
          var freeProductId    = 40384172949602;
          var hasPaidProducts  = paidProductsInCart(cart) > 0;
          var hasFreeProduct   = cart.items.some(function(item) { return item.id === freeProductId; });
          var isCartSubtotalZero = cart.total_price === 0;
          if (hasPaidProducts && !hasFreeProduct && !isCartSubtotalZero) {
            Shopify.Cart.GiftWrap.set(freeProductId, 1);
          } else if ((!hasPaidProducts) && hasFreeProduct) {
            Shopify.Cart.GiftWrap.remove(freeProductId);
          }
        }

        // ── Page-specific logic (uses config flags instead of Liquid) ──────
        var u, h, h3, h4, g4, u4;

        if (config.isTimPage) {
          cart.items.forEach(function(a) {
            if (a.id === 31767730487394) { u = a.quantity; s = a.id; }
            if (a.id === 39611069464674) { h = a.id; g = a.quantity; }
          });
          if (u >= 1 && h !== 39611069464674)   { Shopify.Cart.GiftWrap.set(39611069464674, 1); }
          else if (s != 31767730487394 && h === 39611069464674) { Shopify.Cart.GiftWrap.remove(39611069464674); }
          if (s == 31767730487394) {
            $(".RelatedProduct__Slider:first-child").hide();
            $(".RelatedProduct__Slider[data-prodid='40294838272098']").show();
          }
        }

        if (config.isSubscriptionCollection) {
          var selling_plan_arry = [], sell_count = 0;
          cart.items.forEach(function(a) {
            selling_plan_arry = a.selling_plan_allocation;
            if (selling_plan_arry === undefined) { sell_count++; }
            if (a.id === 40354746794082) { h3 = a.id; g = a.quantity; }
          });
          if (total_price >= 100 && h3 !== 40354746794082 && sell_count < 1) {
            Shopify.Cart.GiftWrap.set(40354746794082, 1);
          } else if ((total_price < 100 || sell_count > 1) && h3 === 40354746794082) {
            Shopify.Cart.GiftWrap.remove(40354746794082);
          }
        } else {
          cart.items.forEach(function(a) {
            if (a.id === 40354746794082) { h3 = a.id; g = a.quantity; }
          });
          if (total_price < 100 && h3 === 40354746794082) {
            Shopify.Cart.GiftWrap.remove(40354746794082);
          }
        }

        if (config.isPuerSpecial) {
          cart.items.forEach(function(a) {
            if (a.id === 29692103032930) { u = a.quantity; s = a.id; }
            if (a.id === 39611069464674) { h = a.id; g = a.quantity; }
          });
          if (u >= 1 && h !== 39611069464674)   { Shopify.Cart.GiftWrap.set(39611069464674, 1); }
          else if (s != 29692103032930 && h === 39611069464674) { Shopify.Cart.GiftWrap.remove(39611069464674); }
        }


        // ── UTM campaign logic ─────────────────────────────────────────────
        if (typeof product_ttl !== "undefined" && product_ttl === 'freesampler') {
          cart.items.forEach(function(a) {
            if (a.id === 39441631346786) { h = a.id; g = a.quantity; }
          });
          if (total_price >= 110 && h !== 39441631346786)   { Shopify.Cart.GiftWrap.set(39441631346786, 1); }
          else if (total_price < 110 && h === 39441631346786) { Shopify.Cart.GiftWrap.remove(39441631346786); }
        }

        var u5, p5;
        if ((product_affliate !== "undefined" && product_affliate === 'affiliate') ||
            config.pageHandle === 'pique-beauty-bt-offers' || config.pageHandle === 'pique-beauty-bt') {
          cart.items.forEach(function(a) {
            if (a.id === 39772516319330) { u5 = a.quantity; p5 = a.id; }
            if (a.id === 41453574717538) { h = a.id; }
          });
          if (u5 >= 1 && h !== 41453574717538)     { Shopify.Cart.GiftWrap.set(41453574717538, 1); }
          else if (p5 !== 39772516319330 && h === 41453574717538) { Shopify.Cart.GiftWrap.remove(41453574717538); }
        } else {
          cart.items.forEach(function(a) {
            if (a.id === 39843214786658) { u4 = a.quantity; p4 = a.id; }
            if (a.id === 41453574717538) { h = a.id; h4 = a.id; }
          });
          if (u4 < 2 && h4 === 41453574717538)     { Shopify.Cart.GiftWrap.remove(41453574717538); }
          else if (p4 !== 39843214786658 && h === 41453574717538) { Shopify.Cart.GiftWrap.remove(41453574717538); }
        }

        if (typeof product_ttl !== "undefined" && product_ttl === 'vcsampler') {
          cart.items.forEach(function(a) {
            if (a.id === 32068087021666) { u = a.quantity; }
            if (a.id === 39441631346786) { h = a.id; }
          });
          if (u >= 2 && h !== 39441631346786)  { Shopify.Cart.GiftWrap.set(39441631346786, 1); }
          else if (u < 2 && h === 39441631346786) { Shopify.Cart.GiftWrap.remove(39441631346786); }
        }

        // ── Single gift wrap item cleanup ──────────────────────────────────
        var giftWrapIds = [39611069464674, 39548746236002, 40384172949602, 40217016500322,
          41453574717538, 42402129051746, 42402135605346, 42584519770210,
          40452231299170, 42220643221602, 42772944650338, 42838950969442, 42838975447138];

        if (cart.item_count === 1) {
          var quantities = {};
          cart.items.forEach(function(item) {
            if (giftWrapIds.includes(item.id)) { quantities[item.id] = item.quantity; }
          });
          giftWrapIds.forEach(function(id) {
            if (quantities[id] === 1) { Shopify.Cart.GiftWrap.remove(id); }
          });
        }
    }

    // ── Core cart recalc ─────────────────────────────────────────────────────
    var recalcRunning = false;
    var recalcQueued = false;
    function recalcEnroute() {
      if (recalcRunning) { recalcQueued = true; return; }
      recalcRunning = true;
      jQuery.getJSON('/cart.js', function(cart) {
        var total_price = cart.total_price / 100;
        var utm_cookie_value    = getCookie("__attentive_utm_param_campaign");
        var refferal_cookie_value = getReferralCampaign();
        var product_ttl         = GetURLParameter('utm_campaign');
        var product_affliate    = GetURLParameter('utm_source');
        var product_medium      = GetURLParameter('utm_medium');

        var hasBundleItems = false;
        var hasShlpBundle = false;
        cart.items.forEach(function(item) {
          // Supply Length plans are priced by their selling plan; never stack a bundle code on them.
          // Discount only — they still count toward free gifts below.
          if (item.properties && item.properties._sl_plan === 'true') return;
          var parent = Number(item.properties && item.properties._bundle_parent);
          var isSub  = !!item.selling_plan_allocation;
          if (parent && isSub) {
            hasBundleItems = true;
          }
          if (item.properties && item.properties._subscription_bundle === 'true') {
            hasBundleItems = true;
          }
          if (parent === 50583489708130 && isSub) {
            hasShlpBundle = true;
          }
        });

        // Determine the correct code for this cart
        var desiredCode = null;
        if (hasShlpBundle) {
          desiredCode = '25OFFSUB';
        } else if (hasBundleItems) {
          desiredCode = BUNDLE_DISCOUNT_CODE; // 20OFFSUB
        }

        var activeCodes = cart.discount_codes.map(function(d){ return d.code; });
        var bundleCodes = ['20OFFSUB', '25OFFSUB'];
        var activeBundleCode = activeCodes.filter(function(c){ return bundleCodes.indexOf(c) !== -1; })[0] || null;

        // Resolve the discount FIRST, then run gifts. This is what makes the
        // code apply before gifts instead of lagging behind them.
        var discountSettled;
        if (desiredCode && activeBundleCode !== desiredCode) {
          discountSettled = clearDiscountCode().then(function() {
            return applyDiscountCode(desiredCode);
          });
        } else if (!desiredCode && activeBundleCode) {
          discountSettled = clearDiscountCode();
        } else {
          discountSettled = Promise.resolve(); // already correct, nothing to do
        }

        if (config.isPuerGhpListicle && cart.discount_codes.length === 0) {
          document.cookie = 'discount_code="20OFFSUBNew"; path=/';
          fetch('/discount/20OFFSUBNew')
            .then(function() {
              return fetch('/cart/update.js', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ updates: {} })
              });
            })
            .catch(function(error) { console.error('Error:', error); });
        }

        // Gifts run only after the discount has settled.
        discountSettled.then(function() {
          runGiftLogic(cart, total_price, refferal_cookie_value, product_ttl, product_affliate);
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        });
      }).always(function() {
        recalcRunning = false;
        if (recalcQueued) { recalcQueued = false; setTimeout(recalcEnroute, 150); }
      });
    }

    // ── Cart update polling ─────────────────────────────────────────────────
    function checkCartUpdate() {
      $.ajax({
        url: '/cart.js', method: 'GET', dataType: 'json',
        success: function() { recalcEnroute(); },
        error: function(error) { console.log("Error fetching cart:", error); }
      });
    }

    var recalcTimer;
    function debouncedRecalc(delay) {
      clearTimeout(recalcTimer);
      recalcTimer = setTimeout(recalcEnroute, delay || 600);
    }

    recalcEnroute();
    document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));

    // Prestige qty handler reads data-quantity, not select.value. Keep it in
    // sync in capture so 2→3 actually posts 3 (3→2 already looked correct).
    document.addEventListener('change', function(event) {
      var qtySelect = event.target && event.target.closest && event.target.closest('select.QuantitySelector__CurrentQuantity');
      if (qtySelect) qtySelect.setAttribute('data-quantity', qtySelect.value);
    }, true);

    // ── Event listeners ─────────────────────────────────────────────────────
    $(document).on("change", "select.QuantitySelector__CurrentQuantity", function() {
      setTimeout(function(){
        recalcEnroute();
      }, 800);
    });
    $(document).on("click", ".CartItem__Remove[data-action='remove-item']", function() {
      setTimeout(checkCartUpdate, 720);
    });
    $('[data-cart-action="subscription"],[data-cart-action="onetime"]').click(function() { setTimeout(checkCartUpdate, 800); });
    $('#mix_main_product').click(function() { setTimeout(checkCartUpdate, 800); });
    $('#mix_main_product_otp').click(function() { setTimeout(checkCartUpdate, 720); });
    $(document).on("click", ".PT242__OptionWidget--Button", function() {
      setTimeout(checkCartUpdate, 700);
    });
        document.addEventListener('product:added', function(ev) {
          var vid = ev && ev.detail && ev.detail.variant;
      var giftVariantIds = [39611069464674, 39548746236002, 40384172949602, 40217016500322,
        41453574717538, 42402129051746, 42402135605346, 42584519770210,
        40452231299170, 42220643221602, 42772944650338, 42838950969442, 42838975447138,
        50571175493730, 43334710329442, 42609638244450, 50589222830178, 42609800282210,
        50523153268834, 39611069464674, 40354746794082, 39441631346786, 41453574717538];
      if (vid && giftVariantIds.indexOf(Number(vid)) !== -1) {
        debouncedRecalc(800);
        return;
      }
      ensureBundleDiscountThenRecalc();
    });

    var ensuringDiscount = false;
    function ensureBundleDiscountThenRecalc() {
      if (ensuringDiscount) { debouncedRecalc(800); return; }
      ensuringDiscount = true;
      fetch('/cart.js').then(function(r){ return r.json(); }).then(function(cart) {
        var hasBundleItems = false, hasShlpBundle = false;
        cart.items.forEach(function(item) {
          if (item.properties && item.properties._sl_plan === 'true') return;
          var parent = Number(item.properties && item.properties._bundle_parent);
          var isSub  = !!item.selling_plan_allocation;
          if (parent && isSub) hasBundleItems = true;
          if (item.properties && item.properties._subscription_bundle === 'true') hasBundleItems = true;
          if (parent === 50583489708130 && isSub) hasShlpBundle = true;
        });
        var desiredCode = hasShlpBundle ? '25OFFSUB' : (hasBundleItems ? BUNDLE_DISCOUNT_CODE : null);
        var active = (cart.discount_codes || []).map(function(d){ return d.code; });
        var hasRight = desiredCode && active.indexOf(desiredCode) !== -1;

        if (desiredCode && !hasRight) {
          // Apply the correct code, THEN recalc gifts.
          return applyDiscountCode(desiredCode).then(function() {
            debouncedRecalc(300);
          });
        }
        // Nothing to apply (or already applied) → just recalc.
        debouncedRecalc(800);
      }).catch(function() {
        debouncedRecalc(800);
      }).finally(function() {
        ensuringDiscount = false;
      });
    }

    $(document).on('change', '.Cart__UpsellQuantity', function() {
      var qunatity_val = this.value;
      $(this).closest(".Swiper__AddAction").find(".Swiper__AddToCart").attr('data-quantity', qunatity_val);
    });

    $(document).on("change", "select[name='selling-plan']", function(e) {
      document.dispatchEvent(new CustomEvent('theme:loading:start'));
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({
          line: e.target.dataset.line,
          quantity: e.target.dataset.quantity,
          selling_plan: e.target.value,
          properties: { _no_discount: "true" }
        })
      }).then(function() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        recalcEnroute();
        document.dispatchEvent(new CustomEvent('theme:loading:end'));
      }).catch(function(error) { console.error('Error:', error); });
    });

    // ── Cart helpers ────────────────────────────────────────────────────────
    function updatePurchasePlan(line, qty, sellingplan) {
      fetch('/cart/change.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ line: line, quantity: qty, selling_plan: sellingplan, properties: { _no_discount: "true" } })
      }).then(function() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        recalcEnroute();
      }).catch(function(error) { console.error('Error:', error); });
    }

    $(document).on("click", "#hs-item-cart-subscription", function(e) {
      e.preventDefault();
      updatePurchasePlan(e.target.dataset.line, e.target.dataset.quantity, e.target.dataset.sellingplan);
    });
    $(document).on("click", "#hs-item-cart-onetime", function(e) {
      e.preventDefault();
      updatePurchasePlan(e.target.dataset.line, e.target.dataset.quantity, e.target.dataset.sellingplan);
    });

    function addUpsellToCart(variant_id, qty) {
      jQuery.ajax({
        type: 'POST', url: '/cart/add.js',
        data: { id: variant_id, quantity: qty }, dataType: 'json',
        success: function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          recalcEnroute();
        }
      });
    }

    function addItemToCart(variant_id, qty) {
      jQuery.ajax({
        type: 'POST', url: '/cart/add.js',
        data: { id: variant_id, quantity: qty }, dataType: 'json',
        success: function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if (config.isSidebarCart) {
            if ($("#sidebar-cart").attr('aria-hidden') === 'true') {
              $("#sidebar-cart").attr("aria-hidden", false);
            }
          } else {
            $('.cart_dr')[0].click();
          }
          recalcEnroute();
        }
      });
    }

    function applySubDiscount() {
      document.cookie = 'discount_code="20OFFSUB"; path=/';
      return fetch('/discount/20OFFSUB')
        .then(function() {
          return fetch('/cart/update.js', {
            method: 'POST',
            headers: { 'Content-Type': 'application/json' },
            body: JSON.stringify({ updates: {} })
          });
        })
        .catch(function(error) { console.error('Discount error:', error); });
    }

    function addItemToCartCollection(variant_id, qty) {
      jQuery.ajax({
        type: 'POST', url: '/cart/add.js',
        data: { id: variant_id, quantity: qty }, dataType: 'json',
        success: function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          $('.cart_dr')[0].click();
          recalcEnroute();
        }
      });
    }

    function sanitizeCartItems(items) {
      return (items || []).reduce(function(clean, item) {
        var id = Number(item && item.id);
        var quantity = Math.max(1, parseInt(item && item.quantity, 10) || 1);
        if (!id) return clean;

        var next = { id: id, quantity: quantity };
        var sellingPlan = Number(item.selling_plan);
        if (sellingPlan) next.selling_plan = sellingPlan;
        if (item.properties) next.properties = item.properties;
        clean.push(next);
        return clean;
      }, []);
    }

    function addBundleToCartHome(itemsArray) {
      var items = sanitizeCartItems(itemsArray);
      if (!items.length) {
        console.error('No valid bundle items to add');
        alert('Could not add bundle.');
        return;
      }

      var isSubBundle = items.some(function(item) {
        return item.properties && item.properties._subscription_bundle === 'true';
      });

      fetch('/cart/add.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ items: items })
      }).then(function(res) {
        return res.json().then(function(payload) {
          if (!res.ok) throw new Error(payload.description || payload.message || 'Add failed');
          return payload;
        });
            }).then(function() {
        var isShlp = items.some(function(it) {
          return it.properties && Number(it.properties._bundle_parent) === 50583489708130;
        });
        if (!isSubBundle && !isShlp) return Promise.resolve();
        var code = isShlp ? '25OFFSUB' : BUNDLE_DISCOUNT_CODE;
        // INSTANT: paint the discounted subtotal now, before the slow call.
        showOptimisticSubtotal(isShlp ? 0.25 : 0.20);
        return applyDiscountCode(code);   // real (Recharge-compatible) apply, in background
      }).then(function() {
        document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
        if ($("#sidebar-cart").attr('aria-hidden') === 'true') {
          $("#sidebar-cart").attr("aria-hidden", false);
        }
        recalcEnroute();   // runs AFTER discount is applied → threshold reads final total
        $('.js-modal-close').trigger('click');
      }).catch(function(error) { console.error(error); alert('Could not add bundle.'); });
    }

    function addBundleToCart(variant_id, quantity, selling_plan) {
      var data = { id: variant_id, quantity: quantity };
      if (selling_plan) { data.selling_plan = selling_plan; data.properties = { _no_discount: "true" }; }
      jQuery.ajax({
        type: 'POST', url: '/cart/add.js', data: data, dataType: 'json',
        success: function() {
          document.documentElement.dispatchEvent(new CustomEvent('cart:refresh', { bubbles: true }));
          if ($("#sidebar-cart").attr('aria-hidden') === 'true') {
            $("#sidebar-cart").attr("aria-hidden", false);
          }
          recalcEnroute();
        }
      });
    }

    function buildBundleItems(variantId, bundleDataRaw, sellingPlanId, quantity, supplyDays) {
      var bundleGroupId = Date.now();
      var qty = Math.max(1, parseInt(quantity, 10) || 1);
      var days = parseInt(supplyDays, 10) || 0;
      var planId = sellingPlanId ? String(sellingPlanId).trim() : '';
      if (!bundleDataRaw) {
        var solo = { id: Number(variantId), quantity: qty, properties: { _no_discount: "true" } };
        if (planId) solo.selling_plan = planId;
        if (days > 0) solo.properties._sl_plan = "true";
        if (days > 30) solo.properties._supply_length = days + "-day";
        return [solo];
      }

      var parsed = [];
      try {
        parsed = JSON.parse(bundleDataRaw);
      } catch (error) {
        console.error('Invalid bundle data', error);
        return [];
      }

      return parsed.map(function(item) {
        var properties = { _bundle_id: bundleGroupId, _bundle_parent: variantId, _no_discount: "true" };
        // Supply Length plans carry their own discount; `_sl_plan` keeps them out of 20OFFSUB/25OFFSUB.
        if (days > 0) properties._sl_plan = "true";
        if (days > 30) properties._supply_length = days + "-day";
        var itemObj = { id: item.id, quantity: qty, properties: properties };
        if (planId) {
          var matchedPlan = item.plans && days ? item.plans[String(days)] : null;
          var nextPlan = matchedPlan || item.selling_plan || null;
          if (nextPlan) itemObj.selling_plan = nextPlan;
        }
        return itemObj;
      });
    }

    $(document).on('click', '.upsell_cart', function() {
      addUpsellToCart($(this).attr("data-var_id"), $(this).attr("data-quantity"));
    });
    $('.ad_to_cart_coll').click(function() {
      addItemToCart($(this).attr("data-var_id"), 1);
    });
    $(document).on('click', '.ad_to_cart_collect', function() {
      addItemToCartCollection($(this).attr("data-var_id"), 1);
    });

    $(document).on('click', '.subscription_addtocart_cart', function(e) {
      e.preventDefault();
      var parentVariantId = $(this).attr('data-var_id');
      var bundleDataRaw   = $(this).attr('data-bundle-data');
      var bundleGroupId   = Date.now();
      if (bundleDataRaw) {
        var itemsToAdd = JSON.parse(bundleDataRaw).map(function(item) {
          return { id: item.id, quantity: 1, selling_plan: item.selling_plan,
            properties: { _bundle_id: bundleGroupId, _bundle_parent: parentVariantId, _subscription_bundle: "true" } };
        });
        addBundleToCartHome(itemsToAdd);
      } else {
        var Freq = $(this).siblings('.rc_shipping_interval_frequency').find(":selected").val();
        addBundleToCart($(this).siblings("input[name='id']").val(), parseInt($(this).attr('data-qantity')), Freq);
      }
    });

    $('.subscription_addtocart_item, .subscription_addtocart').click(function(e) {
      e.preventDefault();
      var parentVariantId = $(this).attr('data-var_id');
      var bundleDataRaw   = $(this).attr('data-bundle-data');
      var bundleGroupId   = Date.now();
      if (bundleDataRaw) {
        var itemsToAdd = JSON.parse(bundleDataRaw).map(function(item) {
          return { id: item.id, quantity: 1, selling_plan: item.selling_plan,
            properties: { _bundle_id: bundleGroupId, _bundle_parent: parentVariantId, _subscription_bundle: "true" } };
        });
        addBundleToCartHome(itemsToAdd);
      } else {
        var freq = $(this).siblings('.rc_shipping_interval_frequency').find(":selected").val();
        addBundleToCartHome([{ id: parentVariantId, quantity: 1, selling_plan: freq, properties: { _no_discount: "true" } }]);
      }
    });

    document.addEventListener("click", function(e) {
      var homeBtn = e.target.closest(".js-bundle");
      if (homeBtn) {
        e.preventDefault();
        addBundleToCartHome(buildBundleItems(
          homeBtn.getAttribute("data-var_id"),
          homeBtn.getAttribute("data-bundle-data"),
          homeBtn.getAttribute("data-selling-plan") || null
        ));
      }
      var pdpBtn = e.target.closest(".pdpBundleBtn");
      if (pdpBtn) {
        e.preventDefault();
        var sellingPlanId = document.querySelector('input[name="selling_plan"]');
        addBundleToCartHome(buildBundleItems(
          pdpBtn.getAttribute("data-var_id"),
          pdpBtn.getAttribute("data-bundle-data"),
          sellingPlanId ? sellingPlanId.value.trim() || null : null
        ));
      }
    });

    // Expose functions globally for any inline calls elsewhere in theme
    window.PiqueCart = {
      addItemToCart: addItemToCart,
      addItemToCartCollection: addItemToCartCollection,
      addUpsellToCart: addUpsellToCart,
      addBundleToCart: addBundleToCart,
      addBundleToCartHome: addBundleToCartHome,
      buildBundleItems: buildBundleItems,
      recalcEnroute: recalcEnroute
    };
  }

  init();
})();